import React, { useEffect, useState } from 'react';

import { Breadcrumb } from 'antd';
import classNames from 'classnames';
import styled from 'styled-components';

import { COMPANY_COMMUNITY_RELATION_TYPE } from 'constants/company';

import { useAppSelector } from '../../store/hook';

const StyledBreadcrumb = styled(Breadcrumb)`
  li {
    color: var(--positive-green);

    .competitor {
      color: var(--competitor-purple);
    }

    &:last-child {
      color: var(--text-secondary);
    }
  }
`;

const HeaderBreadcrumbs = () => {
  const { selectedCompany, selectedCommunity } = useAppSelector((state) => state.global);
  const [items, setItems] = useState<any>([]);

  useEffect(() => {
    if (selectedCommunity) {
      const isCompetitor = selectedCommunity.type === COMPANY_COMMUNITY_RELATION_TYPE.COMPETITOR;
      const title = isCompetitor ? 'Competitor Community' : 'My community';

      setItems([
        {
          title: title,
          className: classNames({ competitor: isCompetitor }),
        },
        { title: selectedCommunity.address },
      ]);
    } else if (selectedCompany) {
      setItems([
        {
          title: 'Company',
        },
        { title: ` ${selectedCompany.name}` },
      ]);
    }
  }, [selectedCompany, selectedCommunity]);

  return <StyledBreadcrumb items={items} separator="·" />;
};

export default HeaderBreadcrumbs;
